export default __webpack_public_path__ + "static/media/vf-logo-icon-red.525f5781.svg";